import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import Asset from "../../models/asset";
import AssetForm from "./AssetForm";

interface AssetUpdateModalProps {
  show: boolean;
  asset?: Asset;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const AssetUpdateModal: React.FC<AssetUpdateModalProps> = ({
  show,
  asset,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = asset
    ? `Editar Productor: ${asset.name}`
    : `Crear Productor nuevo`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <AssetForm
              initialAsset={asset}
              onCancel={onCancel}
              onSuccess={onSuccess}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default AssetUpdateModal;
